// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"063f6c2c","513":"1306bb05","703":"753d6b46"}[chunkId] + ".chunk.js";
};